import React, { useState } from 'react';
import Topnavigation from './Topnavigation';
import Footer from './Footer';
import SEO from './SEO';

const Contact_us = () => {
  const initialState = {
    name: '', lastName: '', email: '',
    contactNumber: '', address: '', remarks: '', medium: '', course: '',
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);

  const validate = (data) => {
    const errs = {};
    if (!data.name.trim())
      errs.name = 'Name is required';
    else if (!/^[a-zA-Z\s]+$/.test(data.name.trim()))
      errs.name = 'Name must contain letters only';

    if (!data.lastName.trim())
      errs.lastName = 'Last name is required';
    else if (!/^[a-zA-Z\s]+$/.test(data.lastName.trim()))
      errs.lastName = 'Last name must contain letters only';

    if (!data.email.trim())
      errs.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(data.email))
      errs.email = 'Enter a valid email address';

    if (!data.contactNumber)
      errs.contactNumber = 'Mobile number is required';
    else if (!/^\d{10}$/.test(data.contactNumber))
      errs.contactNumber = 'Enter a valid 10-digit mobile number';

    if (!data.address.trim())
      errs.address = 'Address is required';

    if (!data.medium)
      errs.medium = 'Please select a medium';

    if (!data.course)
      errs.course = 'Please select a course';

    if (!data.remarks.trim())
      errs.remarks = 'Remarks are required';

    return errs;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Clear error for this field as user types
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate(formData);
    if (Object.keys(errs).length === 0) {
      setSuccess(true);
      setErrors({});
      setFormData(initialState);
    } else {
      setErrors(errs);
      setSuccess(false);
    }
  };

  const fieldClass = (field) =>
    `form-control ${errors[field] ? 'is-invalid' : formData[field] ? 'is-valid' : ''}`;

  return (
    <>
      <Topnavigation />
      <SEO
        title="Contact Us - Study-Link Coaching Classes Indore"
        description="Contact Study-Link Coaching Classes at 72, Ahilya Nagar, Scheme No. 51, 100 Feet Road, Sangam Nagar, Indore - 452006. Call +91 7999061255 for admissions & enquiries."
        keywords="contact study link indore, coaching admission indore, 7999061255, sangam nagar coaching indore, 100 feet road indore"
        url="/contact-us"
      />
      <div>
        <img src="/assets/img/bag01.jpg" style={{ width: '100%', height: 'auto', maxHeight: 400, objectFit: 'cover' }} alt="Contact" />
      </div>

      <div className="container" style={{ marginTop: 40, marginBottom: 60 }}>
        <h2 style={{ textAlign: 'center', marginBottom: 30 }}>Contact Us</h2>

        {success && (
          <div className="alert alert-success alert-dismissible" role="alert">
            ✅ Your inquiry has been submitted successfully! We will contact you soon.
            <button type="button" className="close" onClick={() => setSuccess(false)}>
              <span>&times;</span>
            </button>
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="row">
            <div className="col-12 col-md-8">
              <div className="row">

                <div className="col-12 col-sm-6 mb-3">
                  <input
                    className={fieldClass('name')}
                    type="text" name="name" placeholder="First Name *"
                    value={formData.name} onChange={handleInputChange}
                  />
                  {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                </div>

                <div className="col-12 col-sm-6 mb-3">
                  <input
                    className={fieldClass('lastName')}
                    type="text" name="lastName" placeholder="Last Name *"
                    value={formData.lastName} onChange={handleInputChange}
                  />
                  {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
                </div>

                <div className="col-12 col-sm-6 mb-3">
                  <input
                    className={fieldClass('contactNumber')}
                    type="tel" name="contactNumber" placeholder="Contact No. *" maxLength={10}
                    value={formData.contactNumber} onChange={handleInputChange}
                  />
                  {errors.contactNumber && <div className="invalid-feedback">{errors.contactNumber}</div>}
                </div>

                <div className="col-12 col-sm-6 mb-3">
                  <input
                    className={fieldClass('email')}
                    type="email" name="email" placeholder="Email Id *"
                    value={formData.email} onChange={handleInputChange}
                  />
                  {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>

                <div className="col-12 mb-3">
                  <textarea
                    className={fieldClass('address')}
                    name="address" placeholder="Place of Residence *"
                    value={formData.address} onChange={handleInputChange} rows="3"
                  ></textarea>
                  {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                </div>

                <div className="col-12 col-sm-6 mb-3">
                  <select className={fieldClass('medium')} name="medium" value={formData.medium} onChange={handleInputChange}>
                    <option value="">Select Medium *</option>
                    <option value="Hindi Medium">Hindi Medium</option>
                    <option value="English Medium">English Medium</option>
                    <option value="CBSE">CBSE</option>
                  </select>
                  {errors.medium && <div className="invalid-feedback">{errors.medium}</div>}
                </div>

                <div className="col-12 col-sm-6 mb-3">
                  <select className={fieldClass('course')} name="course" value={formData.course} onChange={handleInputChange}>
                    <option value="">Select Course *</option>
                    <option value="9th">9th</option>
                    <option value="10th">10th</option>
                    <option value="11th">11th</option>
                    <option value="12th">12th</option>
                    <option value="PCM">PCM</option>
                    <option value="BIO">BIO</option>
                    <option value="COMMERCE">COMMERCE</option>
                  </select>
                  {errors.course && <div className="invalid-feedback">{errors.course}</div>}
                </div>

                <div className="col-12 mb-3">
                  <textarea
                    className={fieldClass('remarks')}
                    name="remarks" placeholder="Remarks *"
                    value={formData.remarks} onChange={handleInputChange} rows="3"
                  ></textarea>
                  {errors.remarks && <div className="invalid-feedback">{errors.remarks}</div>}
                </div>

                <div className="col-12">
                  <button type="submit" className="btn btn-success px-4">Submit</button>
                </div>

              </div>
            </div>

            <div className="col-12 col-md-4 mt-4 mt-md-0" style={{ minHeight: 300 }}>
              <img
                src="/assets/img/classcon00.png"
                alt="Contact"
                style={{
                  width: '100%',
                  height: '100%',
                  minHeight: 300,
                  objectFit: 'cover',
                  borderRadius: 8,
                  position: 'sticky',
                  top: 100,
                }}
              />
            </div>
          </div>
        </form>
      </div>

      <Footer />
    </>
  );
};

export default Contact_us;
